import { CampoDoMotivo } from './CampoDoMotivo';

import { fraseDaContingencia, MAXIMO_DA_CONTINGENCIA, MINIMO_DA_CONTINGENCIA } from '@/lib/contingencia';

/**
 * A CONTINGÊNCIA DO MESTRE na mesa (0109): depois da recusa da regra I6, a
 * frase de quem é o mestre e, para quem tem `integracao.contingencia`, o campo
 * do motivo. O botão de gravar fica com quem chama, que troca o rótulo para
 * "… em contingência" (p.30: o botão diz o que acontece).
 */
export function CampoDaContingencia({ recusa, podeDeclarar, motivo, aoMudar }: {
  readonly recusa: { readonly entidade: string; readonly mestre: string };
  readonly podeDeclarar: boolean;
  readonly motivo: string;
  readonly aoMudar: (valor: string) => void;
}) {
  return (
    <div className="flex flex-col gap-3 rounded-controle border border-borda bg-atencao-fundo p-3">
      <p className="txt-apoio text-pretty text-atencao-texto">{fraseDaContingencia(recusa, podeDeclarar)}</p>
      {podeDeclarar ? (
        <CampoDoMotivo
          rotulo="Motivo da contingência"
          valor={motivo}
          aoMudar={aoMudar}
          minimo={MINIMO_DA_CONTINGENCIA}
          maximo={MAXIMO_DA_CONTINGENCIA}
          exemplo="O ERP está fora do ar desde a manhã de hoje"
        />
      ) : null}
    </div>
  );
}
